$(function () {
    deSVG('.my_svg', true);
});
